import React, { useState, useCallback, useEffect } from "react";
import ProgressFile from "./ProgressFile";
import axios from "axios";
import uuid from "react-uuid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthBlocker from "./AuthBlocker";
import { useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
import apiUrls from "../config.js";
import { useAccessToken } from '../AccessTokenProvider';

import LoggerComponent from '../LoggerComponent.js';
import mensajesLog from "../mensajesLog.js";


const CargarArchivos = () => {
  const { accessToken } = useAccessToken();
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const [archivosPrecargado, setArchivosPrecargado] = useState(null);
  const [archivos, setArchivosItem] = useState([]);
  const [isActiveBtnEnviar, setisActiveBtnEnviar] = useState(false);
  const [isActiveBtnseleccionar, setisActiveBtnseleccionar] = useState(false);
  const [idUsuario, setIdUsuario] = useState(0);
  const [idSujetoObligado, setIdSujetoObligado] = useState(0);
  const [folio, setFolio] = useState(null);
  const [tokenIsValid, setTokenIsValid] = useState(false);
  const [msg, setmsg] = useState("Validando acceso...");
  const [datoUsuario, setDatoUsuario] = useState("");
  const [inputValue, setInputValue] = useState('');
  const location = useLocation();
  const [jwt,setjwt]=useState("");
  const loggerInstance = LoggerComponent();
  if (accessToken) {
       getToken(accessToken);
    }
  
 
  useEffect(() => {
    forceUpdate();

    //const parametros = new URLSearchParams(location.search);
    //const token = parametros.get("access_token").replace(/ /g, "+");
    //getToken(token);
  }, [forceUpdate, location.search]);

  const updateArchivo = async (archivoUpdate) => {
    const newArchivo = archivos.filter(
      (archivo) =>
        archivo.nombreArchivo === archivoUpdate ||
        archivo.nombreArchivo.replace(/ /g, "_") === archivoUpdate
    );
    newArchivo[0].completed = 100;
    newArchivo[0].estado = "Cargado";
    forceUpdate();
  };
  const updateArchivoError = (archivoUpdate) => {
    const newArchivo = archivos.filter(
      (archivo) =>
        archivo.nombreArchivo === archivoUpdate ||
        archivo.nombreArchivo.replace(/ /g, "_") === archivoUpdate
    );
    newArchivo[0].completed = 100;
    newArchivo[0].estado = "Error";
    forceUpdate();
    return newArchivo[0].nombreArchivo;
  };

  const subirArchivos = (e) => {
    setArchivosPrecargado(null);
    setArchivosPrecargado(e);
    if (e.length === 1) {
      setInputValue(e[0].name);
    } else if (e.length > 1) {
      setInputValue(`${e.length} Archivos`);
    } else {
      setInputValue('');
    }

    insertarAchivos(e);
  };
  const insertarAchivos = async (e) => {
    setArchivosItem([]);
    forceUpdate();
    let nuevosArchivos = [];
    for (let index = 0; index < e.length; index++) {
      const archivosUser = {
        id: uuid(),
        nombreArchivo: e[index].name,
        completed: "20",
        tipo: e[index].type,
        tamano: e[index].size,
        estado: "Pendiente",
        fechaCarga: "2023-01-18"
      };
      nuevosArchivos.push(archivosUser);
    }
    setArchivosItem(nuevosArchivos);
    forceUpdate();
    setisActiveBtnEnviar(false);
  };

  async function getToken(token) {
    const f = {
      jwt: token
    };
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    await axios
      .post(apiUrls.desencriptar, f, config)
      .then(async (response) => {
        try {
          var decodedToken = jwtDecode(response.data.jwt, { complete: true });
          const ahora = Date.now() / 1000;
          const data = {
            level: 'info',
            mensaje: response.data.jwt,
            accion: mensajesLog.CargarArchivosEntro
          };
          loggerInstance.sendDataToApi(data);
          if (decodedToken.exp < ahora) {
            throw new Error("Token no valido");
          }
          setIdUsuario(decodedToken.idUsuario);
          setIdSujetoObligado(decodedToken.idConcesionario);
          if (
            typeof decodedToken.idTramiteControl !== "undefined" &&
            decodedToken.idTramiteControl !== null
          ) {
            setFolio(decodedToken.idTramiteControl);
          } else {
            setFolio("0");
          }
          setjwt(response.data.jwt);         
          
          setDatoUsuario(decodedToken.email);
          setTokenIsValid(true);
        } catch (error) {
          console.log(error);
          setmsg("Usted no tiene acceso a este sistema");
          setTokenIsValid(false);
          const data = {
            level: 'info',
            mensaje: jwt,
            accion: mensajesLog.CargarArchivosEntro
          };
          loggerInstance.sendDataToApi(data);
        }
      })
      .catch((error) => {
        console.log(error);
        setmsg("Usted no tiene acceso a este sistema");
        setTokenIsValid(false);
        const data = {
            level: 'info',
            mensaje: jwt,
            accion: mensajesLog.ErrorAccesoSNII
          };
          loggerInstance.sendDataToApi(data);
      });
  }
  async function enviarArchivos() {
    if (archivos.length === 0) {
      toast.warn("Seleccione un archivo!");
    } else {
      setisActiveBtnEnviar(true);
      setisActiveBtnseleccionar(true);
      const f = new FormData();

      for (let index = 0; index < archivosPrecargado.length; index++) {
        f.append("files", archivosPrecargado[index]);
      }
      f.append("idUsuario", idUsuario);
      f.append("idConcesionario", idSujetoObligado);
      f.append("idTramiteControl", folio);

      const headers = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Content-Type": "multipart/form-data"
      };

      await axios
        .post(apiUrls.subirArchivos, f, { headers })
        .then(async (response) => {
          let archivosCorrectos = [];
          let archivosIncorrectos = [];

          for (let i = 0; i < response.data.Respuesta.length; i++) {
            setTimeout(() => {
              if (response.data.Respuesta[i].completed === 100) {
                updateArchivo(response.data.Respuesta[i].nombre);
                archivosCorrectos.push(response.data.Respuesta[i].nombre); 
              } else {
                archivosIncorrectos.push(
                  updateArchivoError(response.data.Respuesta[i].nombre)                  
                );
              }
            }, 1000);
          }
          setTimeout(() => {
            if (archivosCorrectos.length > 0) {
              let messageOK = "Carga correcta: ";
              messageOK += archivosCorrectos.join(" | ");
              toast.success(messageOK);
              const data = {
                level: 'info',
                mensaje: jwt,
                accion: mensajesLog.CargarArchivosEnvio+": "+archivosCorrectos.join(" | ")
              };
              loggerInstance.sendDataToApi(data);
            }
            if (archivosIncorrectos.length > 0) {
              let messageError = "Error de carga: ";
              messageError += archivosIncorrectos.join(" | ");
              toast.warn(messageError);
              const data = {
                level: 'info',
                mensaje: jwt,
                accion: mensajesLog.CargarArchivosEnvioError+": "+archivosIncorrectos.join(" | ")
              };
              loggerInstance.sendDataToApi(data);
            }
          }, 1000);
          setisActiveBtnseleccionar(false);
        })
        .catch((error) => {
          for (let index = 0; index < archivos.length; index++) {
            setTimeout(() => {
              updateArchivoError(archivos[index].nombreArchivo);
              const data = {
                level: 'info',
                mensaje: jwt,
                accion: mensajesLog.CargarArchivosEnvioError+": "+archivos[index].nombreArchivo
              };
              loggerInstance.sendDataToApi(data);
            }, 2000 * index);
          }
          setisActiveBtnseleccionar(false);
          console.log(error);
          toast.warn("Error de carga, ingrese de nuevo a Ventana IFT !");
          setmsg("Error de carga, ingrese de nuevo a Ventana IFT");
          setTokenIsValid(false);
        });
    }
  }

  return (
    <>
  <AuthBlocker tokenIsValid={tokenIsValid} msg={msg} />
 
   
      <div className="container-fluid">
        <div id="contentroot">
          <div className="row mb-3 mt-3 text-gray-500">
            <div className="card shadow mb-4">
              <div className="card-body text-center shadow">
                <img
                  className="border rounded-circle mb-3 mt-4"
                  src="assets/img/avatars/SNIILOGO-centro.png?h=d877a14f0450101d7855d13e62decc4e"
                  alt="avatar snii"
                  style={{ width: "142px" }}
                />
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col">
                      <div className="mb-3 text-center text-gray-500">
                        <h5 className="text-gray-500 fw-bold">Bienvenido</h5>
                        <label className="form-label form-label">
                          &nbsp;{datoUsuario}
                        </label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="card shadow mb-4">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-6">
                      <h5 className="mb-4 text-gray-500 fw-bold">
                        Selección y Carga de Archivos
                      </h5>
                    </div>

                    <div className="mb-6">
                      <br />
                      <div
                        className="input-group text-gray-500 fw-bold"
                        style={{ width: "90%" }}
                      >
                          <label  className={`btn btn-secondary text-gray-500  ${isActiveBtnseleccionar ? 'disabled' : ''}`} aria-describedby="inputGroupFileAddon04"
                   style={{
                    background: '#e1e4ee',
                    color: 'gray', // Cambiado de text-gray-500 a color
                    borderTopRightRadius: 0, // Usamos camelCase para propiedades de estilo
                    borderBottomRightRadius: 0, // Usamos camelCase para propiedades de estilo
                    border: '1px solid #d1d3e2',
                  }}
                     >
                      <input
                        type="file"
                        multiple
                        className="form-control visually-hidden"
                        disabled={isActiveBtnseleccionar}
                        onChange={(e) => subirArchivos(e.target.files)}
                        accept="es"
                        id="inputGroupFile04"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                        />
                        <span   className={`d-inline ${isActiveBtnseleccionar ? 'disabled' : ''}`} >Elegir archivos</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={inputValue}
                        disabled
                      />
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="inputGroupFileAddon04"
                        onClick={() => enviarArchivos()}
                        disabled={isActiveBtnEnviar}
                      >
                        Cargar
                      </button>
                        {/* ...contenido de input y botón */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
          <ProgressFile archivos={archivos} />
        </div>
         <footer className="bg-white sticky-footer">
        <div className="container my-auto">
          <div className="text-center my-auto copyright">
            <span>Copyright © -is-2023</span>
          </div>
        </div>
      </footer>
      </div>
     
   

    {/* ToastContainer */}
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />

</>
  );
};
export default CargarArchivos;
